export default "__VITE_ASSET__DFmAwwM5__"